<template>
  <div class="uh-item" v-for="item in chatList" :key="item.chatId">
    <div class="top">
      <div class="head">
        <div class="logo-box">
          <img :src="getImageUrl(item.entranceLogoImageUrl)" @error="handleImageError" alt="" />
        </div>
        <div>
          <span :class="`badge2 ${item.chatType}`">{{ t(`label_${item.chatType}`) }}</span>
          <p class="room-name">{{ item.chatName }}</p>
        </div>
      </div>

      <ul class="time">
        <li>
          <span class="tt">{{ t('label_interpretation_start_time') }}</span>
          <span>{{ item.startedDisplayDate }}</span>
        </li>
        <li>
          <span class="tt">{{ t('label_interpretation_end_time') }}</span>
          <span>{{ item.endedDisplayDate }}</span>
        </li>
      </ul>
    </div>

    <div class="bottom">
      <p>{{ t('label_attendees') }}</p>
      <div class="participant-wrap">
        <ul class="participant-list">
          <li v-for="attendee in item.attendees" :key="attendee">{{ attendee }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ChatDetailItem } from '@/types/components';

withDefaults(
  defineProps<{
    chatList: ChatDetailItem[];
  }>(),
  {
    chatList: () => [],
  }
);

const { t } = useI18n();

const getImageUrl = (url) => {
  return url ?? '/images/logo-sconai.png';
};

const handleImageError = (event: Event) => {
  (event.target as HTMLImageElement).src = '/images/logo-sconai.png';
};
</script>

<style scroped lang="scss">
.uh-item {
  border: 1px solid $color-gray-40;
  padding: 1.25rem;
  border-radius: $size-m;
  margin-bottom: $size-m;
  &:last-child {
    margin-bottom: 0;
  }
  .top {
    .head {
      display: flex;
      gap: $size-s;
      .logo-box {
        width: 40px;
        height: 40px;
        border-radius: 0.875rem;
        border: 1px solid $color-gray-40;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      p {
        margin-top: $size-xs;
        font-size: $font-size-psmall;
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        max-width: calc(100vw - 136px);
      }
    }
    .time {
      position: relative;
      padding-left: $size-s;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        width: 3px;
        height: 100%;
        background: $color-gray-40;
      }
      li {
        padding: 0.25rem 0;
        display: flex;
        justify-content: space-between;
        span {
          font-size: $font-size-psmall;
          &.tt {
            color: $color-gray-100;
          }
        }
      }
    }
  }
  .bottom {
    margin-top: 1rem;
    p {
      font-size: $font-size-psmall;
      margin-bottom: $size-xs;
    }
    .participant-wrap {
      position: relative;
      width: 100%;
      &::after {
        content: '';
        position: absolute;
        height: 100%;
        width: 1.5rem;
        z-index: 1;
        right: 0;
        top: 0;
        pointer-events: none;
        background: linear-gradient(270deg, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0) 100%);
      }
      .participant-list {
        display: flex;
        overflow-x: auto;
        gap: $size-xs;
        padding-right: 1.5rem;
        flex-wrap: wrap;
        &::-webkit-scrollbar {
          display: none;
        }
        li {
          padding: 0.25rem 0.75rem;
          border-radius: 100px;
          border: 1px solid $color-gray-40;
          font-size: $font-size-psmall;
        }
      }
    }
  }
}
</style>
